import { memo } from "react";
import { useNavigate } from "react-router-dom";

const KeyFeatureCard = (props) => {
  const { image, title, text, navigateTo } = props;
  const navigate = useNavigate();

  const handleClick = () => {
    if (navigateTo) {
      navigate(navigateTo);
    }
  };

  return (
    <div
      className="key-feature-card"
      onClick={handleClick}
      style={{ cursor: navigateTo ? "pointer" : "default" }}
    >
      <img
        src={image}
        alt=""
        className="img-fluid"
        style={{ width: "65px", objectFit: "contain" }}
      />
      <div className="key-feature-inner mt-3">
        <h6 className="text-uppercase">{title}</h6>
        <p className="l-grey-text mb-0">{text}</p>
      </div>
    </div>
  );
};

export default memo(KeyFeatureCard);
